import { AlertCircle, Badge, CheckCircle } from '@chain-zen/ui'
import React from 'react'

export interface IVerificationBadgeProps {
  isVerified?: boolean
  singleField?: string
}

// Define status components
const VerifiedIcon = CheckCircle
const UnverifiedIcon = AlertCircle

/**
 * Badge component that shows verification status
 */
export const VerificationBadge = ({ isVerified, singleField }: IVerificationBadgeProps) => {
  if (!singleField || isVerified === undefined) return null

  return (
    <Badge
      variant="outline"
      className={`text-xs px-2 py-0.5 ${
        isVerified ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'
      }`}
    >
      <span className="flex items-center gap-1">
        {isVerified ? <VerifiedIcon className="h-3 w-3" /> : <UnverifiedIcon className="h-3 w-3" />}
        <span>{isVerified ? 'verified' : 'not verified'}</span>
      </span>
    </Badge>
  )
}
